module.exports = __webpack_public_path__ + "img/multilandia_logo_short.d08f52c4.svg";